'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DateTimeFormats = exports.DateTimeFormats = {
    DATE: 'YYYY-MM-DD',
    DATE_IATA: 'DDMMM',
    DATETIME: 'YYYY-MM-DD HH:mm',
    DATETIME_SECONDS: 'YYYY-MM-DD HH:mm:ss',
    DATETIME_ZULU: 'YYYY-MM-DDTHH:mmZ',
    DATETIME_ZULU_WITH_SECONDS: 'YYYY-MM-DDTHH:mm:ssZ',
    FLIGHT_DATE: 'DD MMM YYYY',
    TIME: 'HH:mm',
    TIME_WITH_SECONDS: 'HH:mm:ss',
    TIME_PRECISE: 'HH:mm:ss.fff',
    TIME_STAMP_ZULU: 'YYYY-MM-DDTHH:mm:ss.fffZ',
    TIME_IATA: 'HHmm',
    TIME_IATA_WITH_SECONDS: 'HHmmss',
    TIME_STAMP: 'YYYY-MM-DD HH:mm:ss.fff'
};